import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function DirectorTecnicoPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>

      <Header header={'Directores Técnicos'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerDirectoresTécnicos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver Directores Técnicos'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CadastrarDirectorTécnico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Cadastrar Director Técnico'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CategoriasdeDirectorTécnico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Categorias de Director Técnico'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
